import useWindowSize from 'components/util/useWindowSize'
import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'

const options = [
  {
    description: `We offer a simple structure on pricing, giving you the freedom to control your margins, pricing and incremental revenues. Our comprehensive integration flexibility let's you chose how you offer it to your clients.`,
    title: 'Set Your Own Margins',
  },
  {
    description: `We've partnered with over 100 organisations globally. Whether you use our white-label API or no-code dashboard, we provide everything you need to go live quickly and compliantly.`,
    title: 'Built for Seamless Deployment',
  },
]

const HowYouIntegrate = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm with mail integration',
        desktop: {
          dimensions: {
            height: 820,
            width: 582,
          },
          src: '/images/new/au/robot-arm-mail-zoomed.png',
        },
        mobile: {
          dimensions: {
            height: 602,
            width: 361,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '40%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div
        className='d-flex flex-1 flex-column px-4 pb-10 pb-lg-28 pe-lg-8 pt-lg-33 mt-lg-0 mt-n16'
        style={{
          maxWidth: 565,
        }}
      >
        <h3 className='fw-semibold fs-fluid-36-80 lh-105 mb-5 mb-lg-8'>
          Choose How You <span className='color-pink2'>Integrate</span>
        </h3>
        <div className='d-flex flex-column gap-lg-8 gap-5'>
          {options.map((option, index) => (
            <div key={index}>
              <h4 className='fs-fluid-20-32 lh-114'>{option.title}</h4>
              <div className='fs-fluid-16-20 lh-134 lh-lg-114 color-grey5'>
                {option.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </LeftRobotCard>
  )
}

export default HowYouIntegrate
